import WorkflowStep from "./workflowStep";
import FormSectionFactory from "../formSections/formSectionFactory";
import FormSection from "../formSections/formSection";
import {WorkflowType} from "~/enums/forms/workflowSteps/workflowType";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import Submitter from '@/formability/form_builder/models/workflow/submitter';
import { PermitteeType } from '~/enums/permitteeType';

export default class ApprovalStep extends WorkflowStep implements WorkflowStepInterface {
  has_approval: boolean;
  has_form_section: boolean;
  is_multi_section: boolean;
  form_section: FormSection;

  constructor(form?) {
    super(form);
    this.defineProperty('workflow_type', WorkflowType.approval);
  }

  get titleOrDefault(): string {
    if (this.hasTitle) {
      return this.title;
    } else {
      const completer_name_suffix = this.submitter && this.submitter.fullName ? ` from ${this.submitter.fullName}` : '';
      if (this.isApprovalOrFormSectionStep) {
        if (this.has_approval && this.has_form_section) {
          return `Additional Data and Approval${completer_name_suffix}`;
        } else if (this.has_approval) {
          return `Approval${completer_name_suffix}`;
        } else {
          return `Additional Data${completer_name_suffix}`;
        }
      }
    }
  }

  get isApproval(): boolean {
    return this.has_approval;
  }

  createFormSection(): void {
    if (!this.form_section) {
      this.form_section = FormSectionFactory.create(this);
      this.trackCreationDeletion(this.form_section.client_id, null, this.form_section.asJson(), this.form_section);
    }
  }

  afterAppend(): void {
    super.afterAppend();

    this.submitter = new Submitter(this, { reference_type: PermitteeType.group });
  }

  get canConfigureActions(): boolean {
    return true;
  }

  get canAddActions(): boolean {
    return true;
  }

  get isThirdPartyMultiSection(): boolean {
    return this.has_form_section && this.submitter.thirdPartySubmitter?.isCollection;
  }

  get isMultiSectionSet(): boolean {
    return this.is_multi_section && this.has_form_section && this.submitter.reference_type === PermitteeType.group;
  }
}
